export const addresses = {
  dotNounsArt: "0xbA3d3B1fe0CeBaC20480b3c36C62559e088C3151",
};
